// extracted by mini-css-extract-plugin
export default {"content":"VersionChecker_content__CNkG7","contentHeading":"VersionChecker_contentHeading__fijDJ","modalButton":"VersionChecker_modalButton__7cj6B"};